import React, { useCallback, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';
import _get from 'lodash/get';
import _toLower from 'lodash/toLower';
import _isString from 'lodash/isString';

import { If } from 'utils';
import { UiKit } from 'components';
import { AuthContext } from 'context/AuthContext';
import { useAppContext, useStoreSwitch } from 'utils/hooks';
import ADMIN_ROUTUES from 'config/nav/admin/routes';

export default function ConnectionRedirect() {
  const { replace } = useHistory();
  const { search } = useLocation();

  const queryParams = qs.parse(search, { ignoreQueryPrefix: true });
  const id = _get(queryParams, 'rr_store_id', null);
  const appInstall = _get(queryParams, 'app_install', null);

  const isAppInstall = _toLower(appInstall) === 'true';

  const { isSSREnv } = useAppContext();
  const { accountInfo, accessToStores } = useContext(AuthContext);

  // The URL only selects a store; the store itself (and its name) must come
  // from the stores the backend says this user can access.
  const idKey = isSSREnv ? 'seller_store_guid' : 'rr_store_id';
  const store = _isString(id)
    ? (accessToStores || []).find(item => String(item[idKey]) === id)
    : null;
  const name = _get(store, 'store_name', '');
  const storeUniqueName = _get(store, 'store_unique_name', '');
  const isOpen = !!store && isAppInstall;

  const { isError, isProcessing, onStoreSwitch } = useStoreSwitch();

  const accountName = _get(accountInfo, 'name', '');

  const switchStore = useCallback(() => {
    onStoreSwitch({ id, storeName: name, storeUniqueName });
  }, [id, name, storeUniqueName, onStoreSwitch]);

  const onCancel = useCallback(() => {
    replace(ADMIN_ROUTUES.ACCOUNT_SETTINGS.ROOT);
  }, [replace]);

  return (
    <UiKit.Modal
      isOpen={isOpen}
      backdrop="static"
      onClose={onCancel}
      isProcessing={isProcessing}
    >
      <UiKit.Modal.Header title="Store Connected" />
      <UiKit.Modal.Body>
        <p>
          Congratulations! The store <strong>{name}</strong> is now connected to
          the <strong>{accountName}</strong> account. Let's get the store
          onboarded.
        </p>
        <p className="mb-0">
          <If
            test={!isError}
            otherwise="Something not right! Please complete the onboarding later."
          >
            Switch to this store to start its onboarding.
          </If>
        </p>
      </UiKit.Modal.Body>
      <UiKit.Modal.Footer
        onConfirm={switchStore}
        confirmBtnText="Start Onboarding"
      />
    </UiKit.Modal>
  );
}
